import BaseApiService from "./base-services/baseApi.service";

class CentreApiService extends BaseApiService {
  constructor() {
    super();
  }

  centreList = async () => {
    const url = `/website/centre/list`;
    const res = await this.axiosInstance.get(url);
    return await res.data;
  };

  centreDetails = async (city, centre) => {
    const url = `/website/centre/detail?citySlug=${city}&centreSlug=${centre}`;
    const res = await this.axiosInstance.get(url);
    return await res.data;
  };

  mapData = async () => {
    const url = `/website/centre/google-map`;
    const res = await this.axiosInstance.get(url);
    return await res.data;
  };

  facilitiesList = async () => {
    const url = `/website/facilities/list`;
    const res = await this.axiosInstance.get(url);
    return await res.data;
  };

  getCentreSlug = async ({ payload }) => {
    const url = `/website/locate/city/direct`;
    const res = await this.axiosInstance.post(url, payload);
    return res;
  };

  getCentreListById = async (cityId) => {
    const url = `/website/locate/city/city-centre-list?cityId=${cityId}`;
    const res = await this.axiosInstance.get(url);
    return await res.data;
  };
}
const centreApiService = new CentreApiService();
export { centreApiService };
